import { Aligned, AlignedSourceAware, AlignedTargetAware } from './types';

export function isAlignedSourceAware(
  value: Aligned
): value is AlignedSourceAware {
  return (value as AlignedSourceAware).source !== undefined;
}

export function isAlignedTargetAware(
  value: Aligned
): value is AlignedTargetAware {
  return (value as AlignedTargetAware).target !== undefined;
}
